import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { ElementTypeDto } from './models/ElementTypeDto';
import { ElementTypeSearchCriteria } from './models/ElementTypeSearchCriteria';

class ElementTypesService {
    public getList (criteria: ElementTypeSearchCriteria) {
        return Http.get<Paged<ElementTypeDto>>('elementTypes', criteria);
    }

    public getCatalog () {
        return Http.get<ElementTypeDto[]>('elementTypes/catalog');
    }

    public getById (id: string) {
        return Http.get<ElementTypeDto>('elementTypes/' + id);
    }

    public create (model: ElementTypeDto): Promise<string> {
        return Http.post('elementTypes', model);
    }

    public update (model: ElementTypeDto) {
        return Http.put('elementTypes', model);
    }

    public remove (model: ElementTypeDto) {
        return Http.put('elementTypes/deactivate', model);
    }
}

export default new ElementTypesService();
